//const baseDomain = "http://localhost:8000";
const baseDomain = "https://booking-hjortronvagen-app.fly.dev";
const baseUrl = `${baseDomain}/app/`;

export default ({
    baseUrl
})